<template>
  <div class="battery_content" >
    <!-- 筛选 -->
    <div class="flex_bet" style="padding: 20px 0;">
      <el-input v-model="tableObj.batteryBrand" clearable :placeholder="$t('adminView.BrandOrModel')"
        style="width: auto;" @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <div>
        <el-button type="primary" icon="el-icon-plus" title="添加电池" @click="addOrEdit(null)" />
        <el-button type="primary" icon="el-icon-brush" title="清除电池级联缓存" @click="reloadCa" />
      </div>
    </div>
    <div v-loading="listLoading">
      <el-table :data="tableList" element-loading-text="Loading" border fit highlight-current-row>
        <el-table-column type="expand" style="border-right: none;">
          <template slot-scope="scope">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-col :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.CurrentRate')">
                  <span>{{ scope.row.chargingCurrentRate }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.OutCurrentRate')">
                  <span>{{ scope.row.exitingCurrentRate }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :lg="8">
                <el-form-item label="I">
                  <span>{{ scope.row.i }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :lg="8">
                <el-form-item label="V">
                  <span>{{ scope.row.v }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :lg="8">
                <el-form-item label="T">
                  <span>{{ scope.row.t }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType ==3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc0')">
                  <span>{{ scope.row.soc0 }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType !=3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc10')">
                  <span>{{ scope.row.soc10 }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType !=3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc20')">
                  <span>{{ scope.row.soc20 }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType ==3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc25')">
                  <span>{{ scope.row.soc25 }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType !=3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc30')">
                  <span>{{ scope.row.soc30 }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType !=3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc40')">
                  <span>{{ scope.row.soc40 }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc50')">
                  <span>{{ scope.row.soc50 }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType !=3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc60')">
                  <span>{{ scope.row.soc60 }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType !=3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc70')">
                  <span>{{ scope.row.soc70 }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType ==3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc75')">
                  <span>{{ scope.row.soc75 }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType !=3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc80')">
                  <span>{{ scope.row.soc80 }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="scope.row.batteryType !=3" :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc90')">
                  <span>{{ scope.row.soc90 }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Soc100')">
                  <span>{{ scope.row.soc100 }}</span>
                </el-form-item>
              </el-col>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column :label="$t('adminView.Brand')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryBrand }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminView.Model2')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryModel }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminView.Type')" align="center">
          <template slot-scope="scope">
            <span>{{ getLabel(scope.row.batteryType) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('adminView.CurveNo')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.curveNo }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('basicinfo.SystemVoltage') + 'V'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryVoltage}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminView.Capacity20') + 'AH'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryAh }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="'C6'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryAhC6 }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="'C5'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryAhC5 }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="'C3'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryAhC3 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('yhubReport.Operating')">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="addOrEdit(scope.row)" />
          </template>
        </el-table-column>
      </el-table>

      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :title="isAdd? $t('adminView.add'):$t('adminView.Edit')" width="80%" :visible.sync="createBatteryDialog">
      <div v-loading="popload">
        <el-form ref="batteryForm" :rules="rules" :inline="true" :model="bty" label-position="right"
          label-width="120px">

          <el-form-item :label="$t('adminView.Brand')" prop="batteryBrand">
            <el-input v-model="bty.batteryBrand" />
          </el-form-item>

          <el-form-item :label="$t('adminView.Model2')" prop="batteryModel">
            <el-input v-model="bty.batteryModel" />
          </el-form-item>
          <el-form-item :label="$t('adminView.Type')" prop="batteryType">
            <el-select v-model="bty.batteryType" class="filter-item" filterable>
              <el-option v-for="item in batteryTypeOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <!--曲线编号-->
          <el-form-item :label="$t('adminView.CurveNo')" prop="curveNo">
            <el-input v-model="bty.curveNo" />
          </el-form-item>

          <el-form-item :label="$t('basicinfo.SystemVoltage')" prop="batteryVoltage">
            <el-input-number v-model="bty.batteryVoltage" :precision="0" :step="1" :min="1" />
          </el-form-item>
          <br>

          <el-form-item :label="$t('adminView.Capacity20')" prop="batteryAh">
            <el-input-number v-model="bty.batteryAh" :precision="0" :step="5" :min="0" />
          </el-form-item>
          <el-form-item :label="$t('adminView.Capacity5')" prop="batteryAhC5">
            <el-input-number v-model="bty.batteryAhC5" :precision="0" :step="5" :min="0" />
          </el-form-item>
          <el-form-item :label="$t('adminView.Capacity5').replace('C5','C3')" prop="batteryAhC3">
            <el-input-number v-model="bty.batteryAhC3" :precision="0" :step="5" :min="0" />
          </el-form-item>

          <el-form-item :label="$t('adminView.Capacity5').replace('C5','C6')" prop="batteryAhC6">
            <el-input-number v-model="bty.batteryAhC6" :precision="0" :step="5" :min="0" />
          </el-form-item>
          <br>
          <!--充入速率-->
          <el-form-item :label="$t('adminView.chargeRate')">
            <el-input-number v-model="bty.chargingCurrentRate" :precision="2" :step="0.01" :max="10" :min="0" />
          </el-form-item>

          <!--放电速率-->
          <el-form-item :label="$t('adminView.dischargeRate')">
            <el-input-number v-model="bty.exitingCurrentRate" :precision="2" :step="0.01" :max="10" :min="0" />
          </el-form-item>
          <br>
          <el-form-item label="I" prop="i">
            <el-input v-model="bty.i" :placeholder="$t('adminView.UseComma')" />
          </el-form-item>

          <el-form-item label="V" prop="v">
            <el-input v-model="bty.v" :placeholder="$t('adminView.UseComma')" />
          </el-form-item>

          <el-form-item label="T" prop="t">
            <el-input v-model="bty.t" :placeholder="$t('adminView.UseComma')" />
          </el-form-item>

          <div v-if="bty.batteryType ==3">
            <el-form-item :label="$t('adminView.Soc0')">
              <el-input-number v-model="bty.soc0" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc25')">
              <el-input-number v-model="bty.soc25" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc50')">
              <el-input-number v-model="bty.soc50" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc75')">
              <el-input-number v-model="bty.soc75" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc100')">
              <el-input-number v-model="bty.soc100" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item :label="$t('adminView.Soc10')">
              <el-input-number v-model="bty.soc10" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc20')">
              <el-input-number v-model="bty.soc20" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc30')">
              <el-input-number v-model="bty.soc30" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc40')">
              <el-input-number v-model="bty.soc40" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc50')">
              <el-input-number v-model="bty.soc50" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc60')">
              <el-input-number v-model="bty.soc60" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc70')">
              <el-input-number v-model="bty.soc70" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc80')">
              <el-input-number v-model="bty.soc80" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc90')">
              <el-input-number v-model="bty.soc90" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Soc100')">
              <el-input-number v-model="bty.soc100" :precision="2" :step="0.01" :max="10" :min="0" />
            </el-form-item>

          </div>

        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center;">
          <el-button @click="createBatteryDialog = false">{{ $t('button.Cancel') }}</el-button>
          <el-button v-preventReClick type="primary" @click="submitPop">{{ $t('button.Submit') }}</el-button>
          <el-button v-preventReClick type="primary" @click="submitPop2">新增同款</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageBatterylist, add, update, reloadCascadeCache } from '@/api/settingBattery'
import { pagination } from '@/utils/init_table' // 分页

export default {
  
  data () {
    return {
      tableObj: {},
      tableList: null,
      listLoading: true,
      isAdd: true,
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      createBatteryDialog: false,
      
      batteryTypeOption: [
        { value: 0, label: 'GEL' },
        { value: 1, label: 'AGM' },
        { value: 2, label: 'FLOODE' },
        { value: 3, label: 'Lithium' },
        { value: 4, label: 'Program' },
        { value: 5, label: 'PSY' }
      ],
      
      obty: {},
      bty: {
        batteryAh: 0,
        batteryAhC5: 0,
        batteryAhC6: 0,
        batteryAhC3: 0,
        batteryVoltage: 12,
        batteryBrand: '',
        batteryModel: ' ',
        batteryType: 0,
        chargingCurrentRate: 0.12,
        curveNo: 'b01',
        exitingCurrentRate: 0.03,
        i: '10.0,27.0,6.75,6.75',
        productionYear: null,
        soc0: null,
        soc10: 5.75,
        soc20: 5.83,
        soc25: null,
        soc30: 5.91,
        soc40: 5.98,
        soc50: 6.05,
        soc60: 6.12,
        soc70: 6.19,
        soc75: null,
        soc80: 6.25,
        soc90: 6.31,
        soc100: 6.37,
        t: '1.0,15.0,15.0,15.0',
        v: '1.9,2.35,2.35,2.67'
      },
      popload: true
    }
  },
  computed: {
    
    rules () {
      return {
        curveNo: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        batteryBrand: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        batteryModel: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        batteryType: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        batteryAh: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        i: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        v: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        t: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        batteryVoltage: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }]
      }
    },
  },
  
  created () {
    this.obty = JSON.parse(JSON.stringify(this.bty))
    this.queryList()
  },
  methods: {
    reloadCa () {
      reloadCascadeCache().then(res => {
        if (res.resultCode === 1001) {
          this.$message({
            message: '清除成功！',
            type: 'success'
          });
        } else {
          this.$message.error(res.resultModel + res.resultMessage);
        }
      })
    },
    getLabel (value) {
      const obj = this.batteryTypeOption.find(item => item.value == value)
      if (obj) return obj.label
      return '--'
    },
    queryList () {
      this.listLoading = true
      var param = {
        key: this.tableObj.batteryBrand || '',
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      // console.log('param--', param)
      // param.batteryModel = this.tableObj.batteryBrand
      pageBatterylist(param).then(response => {
        this.tableList = response.resultModel.list
        this.listQuery.pageInfo.total = response.resultModel.total // 分页
        this.listLoading = false
      })
    },
    addOrEdit (params) {
      this.createBatteryDialog = true
      this.popload = false
      if (params) { // 编辑
        console.log(params)
        this.bty = params
        this.bty.batteryType = parseInt(params.batteryType)
        this.obty = JSON.parse(JSON.stringify(this.bty))
        this.isAdd = false
        
      } else { // 新增
        
        this.isAdd = true
        this.obty.id = ''
        this.obty.batteryBrand = ''
        this.obty.batteryModel = ''
        this.obty.curveNo = ''
        this.obty.batteryAh = ''
        this.obty.batteryAhC5 = ''
        this.obty.batteryAhC6 = ''
        this.obty.batteryAhC3 = ''

        this.bty = this.obty
      }
    },
    submitPop2 () {
      this.$refs['batteryForm'].validate((valid) => {
        if (valid) {
          this.popload = true
            this.bty.id = ''
            add(this.bty).then(respone => {
              this.popload = false
              if (respone.resultCode === 1001) {
                this.createBatteryDialog = false
                this.queryList()
              }
            })
          
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitPop () { // 弹窗--提交
      this.$refs['batteryForm'].validate((valid) => {
        if (valid) {
          this.popload = true
          if (this.isAdd) { // 新增
            add(this.bty).then(respone => {
              this.popload = false
              if (respone.resultCode === 1001) {
                this.createBatteryDialog = false
                this.queryList()
              }
            })
          } else {
            update(this.bty).then(respone => {
              this.popload = false
              if (respone.resultCode === 1001) {
                this.createBatteryDialog = false
                this.queryList()
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 筛选改变事件
    changeSearch () {
      if (this.tableObj.batteryBrand) { // 去掉首尾空格
        this.tableObj.batteryBrand = this.tableObj.batteryBrand.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
      this.listQuery.pageInfo.pageNum = 1
      this.listQuery.pageInfo.pageSize = 10
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>
<style lang="scss" scoped >
.battery_content {
  background: #fff;
  padding: 0 20px 20px;
  
}
</style>
